import Name from './NavBar'

export default Name
